// Yes, this file is one giant exception to the rules, it is intentional

/* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */
/* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */

/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { type FC } from 'react';

// eslint-disable-next-line no-unused-vars
import { cssMap, jsx } from '@atlaskit/css';
import { token } from '@atlaskit/tokens';

import { UNSAFE_expValEqualsNoExposure } from '@confluence/feature-experiments';

const styles = cssMap({
	accessRequestsStatusContainer: { position: 'relative' },
	accessRequestsStatusIndicatorOutline: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		width: '10px',
		height: '10px',
		position: 'absolute',
		borderRadius: token('radius.medium'),
		zIndex: 1,
	},
	surfaceBackground: {
		'> div:first-of-type': {
			backgroundColor: token('elevation.surface'),
		},
		'&:hover': {
			// @ts-ignore
			'> div:first-of-type': {
				// This works better than elevation.surface.hovered ... for now
				backgroundColor: token('elevation.surface.raised.hovered'),
			},
		},
		'&:active': {
			// @ts-ignore
			'> div:first-of-type': {
				backgroundColor: token('elevation.surface.pressed'),
			},
		},
	},
	overlayBackground: {
		'> div:first-of-type': {
			backgroundColor: token('elevation.surface.overlay'),
		},
		'&:hover': {
			// @ts-ignore
			'> div:first-of-type': {
				backgroundColor: token('elevation.surface.overlay.hovered'),
			},
		},
		'&:active': {
			// @ts-ignore
			'> div:first-of-type': {
				backgroundColor: token('elevation.surface.overlay.pressed'),
			},
		},
	},
	accessRequestsStatusIndicator: {
		// @ts-ignore
		backgroundColor: token('color.icon.information'),
		width: '6px',
		height: '6px',
		borderRadius: token('radius.medium'),
	},
});

export const NewAccessRequestIndicator: FC<{
	children: React.ReactNode;
	top: number;
	right: number;
	isInsideOverlay?: boolean;
}> = ({ children, top, right, isInsideOverlay = false }) => {
	// eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
	if (!UNSAFE_expValEqualsNoExposure('cc_fe_realtime_access_requests', 'isEnabled', true)) {
		return children;
	}

	return (
		<div
			css={[
				styles.accessRequestsStatusContainer,
				isInsideOverlay ? styles.overlayBackground : styles.surfaceBackground,
			]}
		>
			<div css={[styles.accessRequestsStatusIndicatorOutline]} style={{ top, right }}>
				<div css={styles.accessRequestsStatusIndicator} />
			</div>

			{children}
		</div>
	);
};
